import TeamInvitesTable from './TeamInvitesTable';

export default TeamInvitesTable;
